// antdTokens.ts
import { theme } from 'antd';

const { getDesignToken, defaultAlgorithm, darkAlgorithm } = theme;

type ThemeMode = 'light' | 'dark';

export const getAntdTokens = (mode: ThemeMode = 'light') => {
    const algorithm = mode === 'dark' ? darkAlgorithm : defaultAlgorithm;

    const tokens = getDesignToken({ algorithm });

    return {
        colorBorder: tokens.colorBorder,
        colorBorderSecondary: tokens.colorBorderSecondary,
        colorBgContainer: tokens.colorBgContainer,
        colorText: tokens.colorText,
        colorTextSecondary: tokens.colorTextSecondary,
        colorPrimary: tokens.colorPrimary,
        colorSuccess: tokens.colorSuccess,
        colorBgElevated: tokens.colorBgElevated,
        colorPrimaryHover: tokens.colorPrimaryHover,
        colorTextTertiary: tokens.colorTextTertiary,
        colorTextPlaceholder: tokens.colorTextPlaceholder,
        colorTextDisabled: tokens.colorTextDisabled,
        colorTextLightSolid: tokens.colorTextLightSolid,
        colorFillAlter: tokens.colorFillAlter,
        colorFillTertiary: tokens.colorFillTertiary,
        colorBgContainerDisabled: tokens.colorBgContainerDisabled,
        colorPrimaryBg: tokens.colorPrimaryBg,
        colorPrimaryBgHover: tokens.colorPrimaryBgHover,
        colorPrimaryBorder: tokens.colorPrimaryBorder,
        colorPrimaryText: tokens.colorPrimaryText,
        colorSuccessBg: tokens.colorSuccessBg,
        colorSuccessText: tokens.colorSuccessText,
        colorWarning: tokens.colorWarning,
        colorWarningBg: tokens.colorWarningBg,
        colorWarningBorder: tokens.colorWarningBorder,
        colorWarningText: tokens.colorWarningText,
        colorError: tokens.colorError,
        colorErrorBg: tokens.colorErrorBg,
        colorErrorBorder: tokens.colorErrorBorder,
        colorErrorText: tokens.colorErrorText,
        boxShadowSecondary: tokens.boxShadowSecondary,
        borderRadius: tokens.borderRadius,
        borderRadiusXS: tokens.borderRadiusXS,
        borderRadiusSM: tokens.borderRadiusSM,
        borderRadiusLG: tokens.borderRadiusLG,
        borderRadiusOuter: tokens.borderRadiusOuter,
    };
};
